(function () {
  'use strict';

  function openMobileMenu() {
    var hamburger = document.querySelector('.dmenu_hamburger');
    if (hamburger) {
      hamburger.click();
    }
  }

  var menuIcon = document.getElementById('menuIcon');
  if (menuIcon) {
    menuIcon.addEventListener('click', function (event) {
      event.preventDefault();
      openMobileMenu();
    });
  }

  var nav = document.querySelector('[data-mobile-bottom-nav]');
  if (!nav) return;

  document.body.classList.add('has-mobile-bottom-nav');

  var lastScrollY = window.scrollY;
  var ticking = false;
  var scrollThreshold = 8;

  function updateNavVisibility() {
    var currentScrollY = window.scrollY;

    if (currentScrollY <= 0) {
      nav.classList.remove('is-hidden');
    } else if (currentScrollY > lastScrollY + scrollThreshold) {
      nav.classList.add('is-hidden');
    } else if (currentScrollY < lastScrollY - scrollThreshold) {
      nav.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(updateNavVisibility);
        ticking = true;
      }
    },
    { passive: true }
  );

  var categoriesBtn = nav.querySelector('[data-mobile-nav="categories"]');
  if (categoriesBtn) {
    categoriesBtn.addEventListener('click', function (event) {
      event.preventDefault();

      var menuIcon = document.getElementById('menuIcon');
      if (menuIcon) {
        menuIcon.click();
        return;
      }

      openMobileMenu();
    });
  }
})();
